import OrdersContainer from 'shared/components/OrdersDashboard/components/Container';
import { DIGITAL_ORDERS_CONFIG, OrdersDashboardContext } from 'shared/components/OrdersDashboard/config';
import { usePageViewEvent, useFiltersChangeEvent } from 'shared/gtm/hooks';

function DgcOrders() {
  usePageViewEvent();
  useFiltersChangeEvent();

  return (
    <OrdersDashboardContext.Provider value={DIGITAL_ORDERS_CONFIG}>
      <OrdersContainer />
    </OrdersDashboardContext.Provider>
  );
}

export default DgcOrders;
